const getters = {
    avaiablePress: state => state.avaiablePress,
  };
  
  export default getters;
  